class FormSelect {
    constructor(el) {
        this.root = el;

        if (this.root) {
            this.init();
        }
    }

    init() {
        this.currentValue = this.root.dataset.currentValue;
        this.elementWrapper = this.root.querySelector(
            '[js-custom-select-element-wrapper]'
        );
        this.activeElement = this.elementWrapper?.querySelector(
            '[js-active-element]'
        );
        this.activeElementText = this.activeElement?.querySelector(
            '[js-active-element-text]'
        );
        this.selectItems =
            this.elementWrapper?.querySelectorAll('[js-select-item]');

        this.closestForm = this.root.closest('form');
        this.nativeSelect = this.root.querySelector('select');

        this.disableTextChange = this.root.getAttribute(
            'data-disable-text-change'
        );
        this.baseValue = this.root.dataset.baseValue;
        this.expandedClass = '-expanded';
        this.checkedClass = '-checked';

        this.events();
    }

    events() {
        if (this.activeElement) {
            this.activeElement.addEventListener(
                'click',
                this.handleActiveElementClick.bind(this)
            );
        }

        if (this.selectItems.length) {
            this.selectItems.forEach(item => {
                item.addEventListener(
                    'click',
                    this.handleSelectItemClick.bind(this)
                );
            });
        }

        window.addEventListener('click', this.onWindowClick.bind(this));
    }

    onWindowClick(e) {
        if (!this.root.contains(e.target)) {
            this.elementWrapper.classList.remove(this.expandedClass);
        }
    }

    handleActiveElementClick() {
        if (this.elementWrapper.classList.contains(this.expandedClass)) {
            this.elementWrapper.classList.remove(this.expandedClass);
        } else {
            this.elementWrapper.classList.add(this.expandedClass);
        }
    }

    handleSelectItemClick(e) {
        const item = e.target.closest('[js-select-item]');
        if (!item) return;
        const isChecked = item.classList.contains(this.checkedClass);

        this.selectItems.forEach(element =>
            element.classList.remove(this.checkedClass)
        );

        if (!isChecked) {
            const value = item.dataset.value;
            const label = item.dataset.label;
            this.currentValue = value;
            this.nativeSelect.value = value;
            item.classList.add(this.checkedClass);
            if (!this.disableTextChange) {
                this.activeElementText.textContent = label;
            }
        } else {
            this.nativeSelect.value = '';
            item.classList.remove(this.checkedClass);
            if (!this.disableTextChange) {
                this.activeElementText.textContent = this.baseValue;
            }
        }

        this.nativeSelect.dispatchEvent(new Event('change'));
        this.elementWrapper.classList.remove(this.expandedClass);

        if (this.closestForm) {
            this.closestForm.dispatchEvent(
                new CustomEvent('input', {
                    bubbles: true,
                    detail: {
                        source: 'select',
                        value: this.currentValue,
                        field: this.nativeSelect.name || null,
                    },
                })
            );
        }
    }
}

function initFormSelects(scope = document) {
    const formSelects = scope.querySelectorAll('[js-form-select]');

    formSelects.forEach(el => {
        if (el.dataset.formSelectInitialized === '1') {
            return;
        }

        el.dataset.formSelectInitialized = '1';
        new FormSelect(el);
    });
}

window.mdaInitFormSelects = initFormSelects;

initFormSelects(document);
